import Vue from 'vue'

Vue.prototype.$currency = function (number, code) {
  return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(number)
}